import { createActionGroup, emptyProps, props } from '@ngrx/store';

import { ProjectContactModel } from '../../models/project-contact.model';

export const ProjectContactActions = createActionGroup({
  source: 'PROJECT_CONTACT',
  events: {
    'Reset to Initial state': emptyProps(),
    'Load contacts': props<{ projectId: string }>(),
    'Load contacts success': props<{
      projectId: string;
      contacts: ProjectContactModel.Document[];
    }>(),
    'Load contacts fail': props<{ projectId: string }>(),
    'Create contact': props<{
      projectId: string;
      contact: ProjectContactModel.API.CreateContactDto;
    }>(),
    'Create contact success': props<{
      contact: ProjectContactModel.Document;
    }>(),
    'Create contact fail': emptyProps(),
    'Create contacts': props<{
      projectId: string;
      contacts: ProjectContactModel.API.BulkCreateContactDto;
    }>(),
    'Create contacts success': props<{
      contacts: ProjectContactModel.Document[];
    }>(),
    'Create contacts fail': emptyProps(),
    'Update contact': props<{
      contactId: string;
      payload: ProjectContactModel.API.UpdateContactDto;
    }>(),
    'Update contact success': props<{
      contact: ProjectContactModel.Document;
    }>(),
    'Update contact fail': props<{ contactId: string }>(),
    'Delete contact': props<{ contactId: string }>(),
    'Delete contact success': props<{ contactId: string }>(),
    'Delete contact fail': props<{ contactId: string }>(),
  },
});
